import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { SectionTitle } from './SectionTitle'
import bgImg from '../../assets/mechanicaldesign/20230303170427_75376.jpg'
import lightingImg from '../../assets/mechanicaldesign/Lightnings-industry.png'
import automotiveImg from '../../assets/mechanicaldesign/Automotive-industry.png'
import medicalImg from '../../assets/mechanicaldesign/Medical-Systems.png'
import commsImg from '../../assets/mechanicaldesign/Communication.png'
import industrialImg from '../../assets/mechanicaldesign/Industrial-Control.png'
import powerImg from '../../assets/mechanicaldesign/Power-and-Energy.png'
import aerospaceImg from '../../assets/mechanicaldesign/Defense-Aerospace.png'
import surveillanceImg from '../../assets/mechanicaldesign/Security-Surveillance.png'

const INDUSTRIES = [
    { img: lightingImg, label: 'Lightings' },
    { img: automotiveImg, label: 'Automotive' },
    { img: medicalImg, label: 'Medical Systems' },
    { img: commsImg, label: 'Communications' },
    { img: industrialImg, label: 'Industrial Control' },
    { img: powerImg, label: 'Power & Energy' },
    { img: aerospaceImg, label: 'Aerospace' },
    { img: surveillanceImg, label: 'Surveillance' },
]

const useStyles = makeStyles(() => ({
    section: {
        position: 'relative',
        background: tokens.colorDark,
        padding: '90px 0',
        overflow: 'hidden',
        isolation: 'isolate',
    },
    bg: {
        position: 'absolute',
        inset: 0,
        zIndex: -2,
        backgroundImage: `url(${bgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        '@media (max-width: 860px)': { backgroundAttachment: 'scroll' },
    },
    overlay: {
        position: 'absolute',
        inset: 0,
        zIndex: -1,
        background: 'linear-gradient(120deg, rgba(20,20,26,0.92) 0%, rgba(20,20,26,0.82) 55%, rgba(20,20,26,0.72) 100%)',
    },
    text: {
        maxWidth: 760,
        margin: '0 auto 50px',
        textAlign: 'center',
        color: '#C7C7D1',
        fontSize: '.98rem',
        fontFamily: tokens.fontBody,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        rowGap: 40,
        columnGap: 24,
        '@media (max-width: 1024px)': { gridTemplateColumns: 'repeat(2, 1fr)' },
        '@media (max-width: 640px)': { gridTemplateColumns: '1fr' },
    },
    item: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
        textAlign: 'left',
        '&:hover $img': { transform: 'translateY(-5px) scale(1.05)', borderColor: tokens.colorAccentRed },
    },
    img: {
        flex: '0 0 auto',
        width: 92, height: 92,
        borderRadius: '50%',
        objectFit: 'cover',
        border: '3px solid rgba(255,255,255,0.15)',
        boxShadow: '0 8px 20px rgba(0,0,0,0.35)',
        transition: `transform ${tokens.transition}, border-color ${tokens.transition}`,
        '@media (max-width: 640px)': { width: 72, height: 72 },
    },
    label: { color: '#F2F2F5', fontSize: '1rem', fontWeight: 600 },
}))

export function Industries() {
    const classes = useStyles()
    return (
        <section className={classes.section} id="industries">
            <div className={classes.bg} />
            <div className={classes.overlay} />
            <Container>
                <SectionTitle variant="white">Industries We Serve</SectionTitle>
                <p className={classes.text}>
                    With years of expertise we have served lots of industries, including Lighting,
                    Automotive, Medical Systems, Communications, Industrial Control, Power &amp;
                    Energy, Aerospace, and Surveillance
                </p>
                <div className={classes.grid}>
                    {INDUSTRIES.map((ind) => (
                        <div className={classes.item} key={ind.label}>
                            <img className={classes.img} src={ind.img} alt={`${ind.label} industry`} />
                            <span className={classes.label}>{ind.label}</span>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    )
}
